import { makeUseAxios } from 'axios-hooks';

import { API } from 'src/app/services/axios';
import { apiBlobSettings } from 'src/app/services/settings';

const useAxiosApi = makeUseAxios({
  axios: API,
});

const BASE_PATH = '/admin/files';

export const downloadFileApi = {
  fetchImageAsLink: async (imageId: string) => {
    const response = await API.get<Blob>(`${BASE_PATH}/${imageId}`, {
      ...apiBlobSettings,
    });

    return window.URL.createObjectURL(response.data);
  },

  downloadFile: async (referenceId: string, signal?: AbortSignal) => {
    const response = await API.get<Blob>(`files/${referenceId}`, {
      ...apiBlobSettings,

      signal,
    });

    return response.data;
  },

  useLazyGetFileQuery: (referenceId: string) =>
    useAxiosApi<Blob>(
      {
        url: `${BASE_PATH}/${referenceId}`,
        method: 'GET',
        responseType: 'blob',
      },
      {
        manual: true,
      }
    ),
};
